import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leasePaymentRequestTemplates = [
  {
    id: '-220001',
    language: Language.EN,
    subject: 'Invitation to pay your rent',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>We invite you to pay {{getPaymentTypeSpelling lease invoiceType}} of your rent. Please find all details here: {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-220002',
    language: Language.FR,
    subject: 'Invitation à payer votre loyer',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Nous vous invitons à payer {{getPaymentTypeSpelling lease invoiceType}} de votre bail. Veuillez trouver les détails ici: {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-220003',
    language: Language.NL,
    subject: 'Uitnodiging om uw huur te betalen',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Wij nodigen u uit om {{getPaymentTypeSpelling lease invoiceType}} van uw huurovereenkomst te betalen. Details vindt u hier: {{pdfLink}}.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-220004',
    language: Language.DE,
    subject: 'Einladung zur Mietzahlung',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p><p>Wir laden Sie ein, {{getPaymentTypeSpelling lease invoiceType}} für Ihren Mietvertrag zu bezahlen. Alle Details finden Sie hier: {{pdfLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
